import remarks from '../../api/remarks'

const success = {
    CREATE_REMARKS_SUCCESS: {
        title: "Succès",
        content: "Note créée avec succès"
    },
    EDIT_REMARKS_SUCCESS: {
        title: "Succès",
        content: "Note éditée avec succès"
    },
    DELETE_REMARKS_SUCCESS: {
        title: "Succès",
        content: "Note supprimée avec succès"
    },
}
const errors = {
    GET_REMARKS_LOADING_ERROR: 'Erreur lors du chargement des notes, merci de réessayer',
    CREATE_REMARKS_ERROR: 'Erreur lors de la création de la note, merci de réessayer',
    EDIT_REMARKS_ERROR: 'Erreur lors de l\'édition de la note, merci de réessayer',
    DELETE_REMARKS_ERROR: 'Erreur lors de la suppression de la note, merci de réessayer',
}

// initial state
const state = {
    list: [],
    form: {
        text: null,
    },
    selectedRemark: {
        id: null,
        text: null
    }
}

// getters
const getters = {
}

// actions
const actions = {
    getRemarks({commit, rootState}) {
        remarks.all(rootState.patients.selectedPatient.id, rootState.axios).then(result => {
            commit('setRemarks', result.data.remarks)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_REMARKS_LOADING_ERROR, content: reason
            }, {root: true})

        })
    },
    createRemark({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            remarks.add(rootState.patients.selectedPatient.id, payload, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CREATE_REMARKS_SUCCESS.title,
                    content: success.CREATE_REMARKS_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_REMARKS_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    editRemark({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            remarks.edit(rootState.patients.selectedPatient.id, state.selectedRemark.id, payload, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.EDIT_REMARKS_SUCCESS.title,
                    content: success.EDIT_REMARKS_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.EDIT_REMARKS_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    deleteRemark({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            remarks.delete(rootState.patients.selectedPatient.id, state.selectedRemark.id, payload, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.DELETE_REMARKS_SUCCESS.title,
                    content: success.DELETE_REMARKS_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.DELETE_REMARKS_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    }
}

// mutations
const mutations = {
    setRemarks(state, value) {
        state.list = value
    },
    setFormText(state, value) {
        state.form.text = value
    },
    setSelectedRemark: (state, remark) => {
        state.selectedRemark = remark;
    },
    setSelectedRemarkText: (state, text) => {
        state.selectedRemark.text = text;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
